export default __webpack_public_path__ + "static/media/arrow_left.0a34286d.svg";